import * as Dialog from "../framework/dialog";
import { getUITranslation } from "../utils/get_ui_translation";
import { pdfFileToMarkdown } from "./pdf_importer_hook";

// Images and Excel files are uploaded to the server, PDFs are converted to markdown in the browser
const UPLOAD_NAMES = {
  image: "conversation_picture",
  spreadsheet: "conversation_spreadsheet",
};

const EXTENSION_KINDS = {
  jpg: "image",
  jpeg: "image",
  png: "image",
  pdf: "pdf",
  xlsx: "spreadsheet",
};

/**
 * Groups files by the way they are attached to the conversation, based on their extension.
 * @param {File[]} files
 * @returns {{image: File[], pdf: File[], spreadsheet: File[], unknown: File[]}}
 */
export function groupFilesByKind(files) {
  const groups = { image: [], pdf: [], spreadsheet: [], unknown: [] };

  for (const file of files) {
    const extension = file.name.split(".").pop().toLowerCase();
    groups[EXTENSION_KINDS[extension] || "unknown"].push(file);
  }

  return groups;
}

/**
 * Single entry point to attach files to a Pétronille conversation, from a file input or a drop.
 * Each file is routed to its own processing: LiveView uploads for images and Excel files
 * (hidden live_file_inputs of the form), browser conversion to markdown for PDFs.
 */
const hook = {
  mounted() {
    this.form = this.el.querySelector("form");
    this.input = this.el.querySelector("[data-petronille-files-input]");

    this.input.addEventListener("change", () => {
      this.dispatch(Array.from(this.input.files));
      // Allows selecting the same file again
      this.input.value = "";
    });

    this.el.addEventListener("dragover", (event) => event.preventDefault());
    this.el.addEventListener("drop", (event) => {
      event.preventDefault();
      this.dispatch(Array.from(event.dataTransfer.files));
    });
  },

  dispatch(files) {
    const groups = groupFilesByKind(files);

    for (const kind of ["image", "spreadsheet"]) {
      if (groups[kind].length > 0) this.uploadTo(this.form, UPLOAD_NAMES[kind], groups[kind]);
    }

    for (const file of groups.pdf) {
      pdfFileToMarkdown(file).then((markdown) => {
        if (markdown) this.pushEvent("import_conversation_pdf", { "importer-markdown": markdown, "importer-filename": file.name });
      });
    }

    if (groups.unknown.length > 0) {
      Dialog.alertError(
        getUITranslation("Ce type de fichier n'est pas pris en charge."),
        getUITranslation("Formats acceptés : JPG, PNG, PDF et XLSX.")
      );
    }
  },
};

export default hook;
